import axios from 'axios'
import router from '../../router'

export default {
    namespaced: true,
    state:{
        authenticated:false,
        currentHotel: {
            id: 0,
            name: ''
        },
        currentSpa: {
            id: 0,
            name: ''
        },
        currentBeauty: {
            id: 0,
            name: ''
        },
        currentChain: {
            id: 0,
            name: ''
        },
        user:{}
    },
    getters:{
        getAvailableHotels(state) {
            return typeof state.user.config !== 'undefined' ? state.user.config.hotels : []
        },
        getAvailableHotelsWithoutCurrent (state) {
            if (typeof state.user.config !== 'undefined') {
                return state.user.config.hotels.filter(item => item.value !== state.currentHotel.id)
            } else {
                return []
            }
        },
        getAvailableSpa(state) {
            return typeof state.user.config !== 'undefined' ? state.user.config.spa : []
        },
        getAvailableBeauty(state) {
            return typeof state.user.config !== 'undefined' ? state.user.config.beauty_salons : []
        },
        getAvailableChain(state, rootState, getters, rootGetters) {
            return state.user.hotel_chain_id === null ? rootState['chain/chains'] : state.currentChain
        },
    },
    mutations:{
        SET_AUTHENTICATED (state, value) {
            state.authenticated = value
        },
        CLEAR_DATA (state) {
            state.user = {}
            const defaultData = {
                id: 0,
                name: ''
            }
            state.currentHotel = Object.assign({}, defaultData)
            state.currentSpa = Object.assign({}, defaultData)
            state.currentBeauty = Object.assign({}, defaultData)
            state.currentChain = Object.assign({}, defaultData)
        },
        SET_USER (state, payload) {
            // todo объединить для конфигов в одини методы
            if (typeof payload.config.hotels !== 'undefined') {
                const currentHotel = payload.config.hotels.find(item => item.id === state.currentHotel.id)
                if (typeof currentHotel === 'undefined') {
                    state.currentHotel = {
                        id: payload.config.hotels[0].id,
                        name: payload.config.hotels[0].name
                    }
                }
            }
            if (typeof payload.config.spa !== 'undefined') {
                const currentSpa = payload.config.spa.find(item => item.id === state.currentSpa.id)
                if (typeof currentSpa === 'undefined') {
                    state.currentSpa = {
                        id: payload.config.spa[0].id,
                        name: payload.config.spa[0].name
                    }
                }
            }
            if (typeof payload.config.beauty_salons !== 'undefined') {
                const currentBeauty = payload.config.beauty_salons.find(item => item.id === state.currentBeauty.id)
                if (typeof currentBeauty === 'undefined') {
                    state.currentBeauty = {
                        id: payload.config.beauty_salons[0].id,
                        name: payload.config.beauty_salons[0].name
                    }
                }
            }
            if (payload.hotel_chain_id) {
                const currentChain = payload.hotel_chain_id
                if (currentChain === null) {
                    state.currentChain = {
                        id: payload.hotel_chain_id.id,
                        name: payload.hotel_chain_id.description
                    }
                }
            }
            state.user = payload
        },
        SET_CURRENT_HOTEL (state, payload) {
            state.currentHotel = {
                id: payload.id,
                name: payload.name
            }
        },
        SET_CURRENT_SPA (state, payload) {
            state.currentSpa = {
                id: payload.id,
                name: payload.name
            }
        },
        SET_CURRENT_BEAUTY (state, payload) {
            state.currentBeauty = {
                id: payload.id,
                name: payload.name
            }
        },
        SET_CURRENT_CHAIN (state, payload) {
            state.currentChain = {
                id: payload.id,
                name: payload.name
            }
        }
    },
    actions:{
        async login({state, commit, dispatch, getters, rootGetters, rootState}, auth){
            await axios.get('/sanctum/csrf-cookie')
            return axios.post('/login', auth).then(({data})=>{
                commit('SET_AUTHENTICATED',true)
                if([0,2].includes(data.data.role_id)) {
                    dispatch('chain/fetch', {}, { root: true }).then(()=>{
                        const chain = rootState.chain.chains[0]
                        commit('SET_CURRENT_CHAIN', chain)
                        dispatch('hotel/fetch', {hotel_chain_id: state.currentChain.id}, { root: true }).then(()=>{
                            data.data.config.hotels = rootState.hotel.hotels
                            commit('SET_USER', data.data)
                            router.push({name:'base'})
                        })
                    })
                } else {
                    dispatch('chain/fetch', {}, { root: true }).then(()=>{
                        const chain = rootState.chain.chains.find(item => item.id === data.data.hotel_chain_id)
                        commit('SET_CURRENT_CHAIN', chain)
                        commit('SET_USER', data.data)
                        router.push({name:'base'})
                    })
                }
            }).catch((error)=>{
                commit('CLEAR_DATA', {})
                commit('SET_AUTHENTICATED', false)
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        fetchUser({commit, dispatch}){
            return axios.get('/api/user').then(({data})=>{
                commit('SET_USER',data)
            }).catch((error)=>{
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        logout({commit, dispatch}){
            dispatch('hotel/clear', {}, { root: true })
            commit('CLEAR_DATA',{})
            commit('SET_AUTHENTICATED',false)
            router.replace({name:'login'})
            // костыль для быстрого сброса store
            location.reload()
        }
    }
}
